
class PaymentInstallmentsSelectionCell extends UITableViewCell
{
    private selectionDot:MUIView = null;
    private dateLabel:MUILabel = null;
    private maturityLabel:MUILabel = null;
    private documentLabel:MUILabel = null;
    private clientLabel:MUILabel = null;
    private amountLabel:MUILabel = null;

    awakeFromHTML(): void {
        this.selectionDot = MUIOutlet( this, "selection-dot", "MUIView" );
        this.dateLabel = MUIOutlet( this, "date-lbl", "MUILabel" );
        this.maturityLabel = MUIOutlet( this, "maturity-lbl", "MUILabel" );
        this.documentLabel = MUIOutlet( this, "document-lbl", "MUILabel" );
        this.clientLabel = MUIOutlet( this, "client-lbl", "MUILabel" );
        this.amountLabel = MUIOutlet( this, "amount-lbl", "MUILabel" );

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private installment:PaymentInstallment = null;
    set item( item:PaymentInstallment ) {
        this.installment = item;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        this.dateLabel.text = ad.dateFormatter.stringFromDate( item.date );
        this.maturityLabel.text = item.dueDate != null ? ad.dateFormatter.stringFromDate( item.dueDate ) : null;
        this.amountLabel.text = ad.currencyFormatter.stringFromNumber( item.amount );

        if (item instanceof LegalEntityPaymentInstallment) {
            this.documentLabel.text = item.documentNumber;
            this.clientLabel.text = item.legalEntityName;
        }
        else {
            this.documentLabel.text = null;
            this.clientLabel.text = null;
        }
    }

    set itemSelected( value:boolean ) {
        if (this.selectionDot == null) return;
        if (value) MUICoreLayerAddStyle( this.selectionDot.layer, "active" );
        else MUICoreLayerRemoveStyle( this.selectionDot.layer, "active" );
    }
}
